module.exports = __webpack_public_path__ + "img/exostructure2.5173be9d.png";